// Read-time aliases for renamed element types: persisted DC blobs and published
// releases keep the old `type` forever, so entries stay here permanently.

const DEPRECATED_ELEMENT_TYPE_ALIASES = {
  EventMeeting: "EventVideoRoom",
  EventLiveStream: "EventVideoRoom",
  EventStartsAt: "EventVideoRoom",
  EarlyAccessAt: "EventVideoRoom",
};

function aliasedElementType(elementType) {
  return DEPRECATED_ELEMENT_TYPE_ALIASES[elementType] ?? elementType;
}

// Sits on every element's render path: must never throw and must return an
// unrecognised entry unchanged.
function normalizeDeprecatedElementTypeEntry(entry) {
  if (!entry || typeof entry !== "object") {
    return entry;
  }

  try {
    const aliased = DEPRECATED_ELEMENT_TYPE_ALIASES[entry.type];
    if (!aliased) {
      return entry;
    }

    return { ...entry, type: aliased };
  } catch {
    return entry;
  }
}

module.exports = {
  DEPRECATED_ELEMENT_TYPE_ALIASES,
  aliasedElementType,
  normalizeDeprecatedElementTypeEntry,
};
